import { Mui, omitReduxProps } from "@osu/react-ui";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { API_STATUS } from "../../util/constants";
import { useSelector } from "react-redux";
import { selectAuthenticationStatus } from "../../services/authorization/slices";
import { useState } from "react";
import { authorizationRoutes } from "../../Routes/paths";
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

function AuthButton(props = {}) {
  const { name, ...rest } = props;
  const remainingProps = omitReduxProps(rest);
  const status = useSelector(selectAuthenticationStatus)
  const [inOrOut, setInOrOut] = useState("In")
  const { pathname } = useLocation()
  const onAuthPage = [authorizationRoutes.login, authorizationRoutes.unauthorized].includes(pathname)
  const { user } = useRoleAuthentication();

  if(onAuthPage) {
    return false
  }

  if (status === API_STATUS.LOADING) {
    return (
        <Mui.Box {...remainingProps} className="auth-loading" sx={{display: "flex", flexDirection: "row", alignItems: "center"}}>
          <Mui.CircularProgress size={20} sx={{ marginRight: 1 }}/>
          <Mui.Typography variant="body2" className="loading-text" sx={{ display: { xs: 'none', sm: 'block' } }}>
            {Boolean(inOrOut) && `Signing ${inOrOut}`}
          </Mui.Typography>
        </Mui.Box>
    );
  }

  if (status === API_STATUS.SUCCESS) {
    return (
      <>
        {user.name && (
          <Mui.Typography 
            variant="body2" 
            className="user-name"
            sx={{ 
              display: { xs: 'none', sm: 'block' },
              marginRight: 1
            }}
          >
            {user.name} |
          </Mui.Typography>
        )}
        <Mui.Button 
          onClick={() => setInOrOut("Out")} 
          variant="text" 
          color="secondary" 
          component={RouterLink} 
          to="/logout" 
          className="auth-button"
          size="small"
          {...remainingProps}
        >
          Sign Out
        </Mui.Button>
      </>
    );
  }

  return (
    <Mui.Button 
      onClick={() => setInOrOut("In")} 
      variant="outlined" 
      component={RouterLink} 
      to={"/login"} 
      state={{
        redirectPath: pathname
      }} 
      className="auth-button"
      size="small"
      {...remainingProps}
    >
      Sign In
    </Mui.Button>
  );
}

export default AuthButton;